import SmallUsp from '@/molecules/USPs/small/SmallUsp';
import {StyledColorBlock} from '@/pages/styles';

import {uspContent} from './content';
import {
  StyledImageUspContainer,
  StyledNextImage,
  StyledUspContainer,
  StyledUspHeading,
} from './styles';
import {Props} from './typings';

const UspSection = ({background}: Props) => {
  return (
    <StyledColorBlock $verticalPadding="m" $background={background}>
      <StyledUspHeading>
        Shop original art from independent artists around the world.
      </StyledUspHeading>

      <StyledUspContainer aria-label={'Why choose Artfinder?'}>
        {uspContent.map((usp, i) => {
          if ('icon' in usp) {
            return (
              <SmallUsp key={i} icon={usp.icon} background={usp.background}>
                {usp.children}
              </SmallUsp>
            );
          } else if ('image' in usp) {
            return (
              <StyledImageUspContainer key={i}>
                <StyledNextImage
                  src={`${process.env.NEXT_PUBLIC_IMAGE_STATIC_URL}${usp.image}`}
                  alt={usp.imageDescription}
                  width={120}
                  height={145}
                />

                <p>{usp.children}</p>
              </StyledImageUspContainer>
            );
          }
        })}
      </StyledUspContainer>
    </StyledColorBlock>
  );
};

export default UspSection;
